export class MaxRetentionRule {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "maximumRetention",
            "baseName": "maximumRetention",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return MaxRetentionRule.attributeTypeMap;
    }
    constructor() {
    }
}
